import _ from "lodash";

export function filter (items, maxDepth)
{
	return handleItems(items, maxDepth, 0);
}

function handleItems (items, maxDepth, level)
{
	if (level > maxDepth)
	{
		return [];
	}

	_.forEach(items, item =>
	{
		item.children = handleItems(item.children, maxDepth, level + 1);
	});

	return items;
}